'use strict';

var util = angular.module('gymsystem.util');

util.factory('contractManager', ['$q', '$http', '$modal', function($q, $http, $modal) {
    var self = {};

    self.open = function(option) {
        $modal.open({
            templateUrl: 'components/contractmanager/contractmanager.html',
            controller: 'ContractManager',
            windowClass: 'huge-modal-window',
            resolve: {
                dialogOption: function() {
                    return option;
                }
            }
        });
    };

    return self;
}]);

util.controller('ContractManager', ['$rootScope', '$scope', '$q', '$modal', '$filter', 'contractManager', 'fileManager', 'dialogOption', 'util', 'server', 'alertProvider', 'confirm',
    function($rootScope, $scope, $q, $modal, $filter, contractManager, fileManager, dialogOption, util, server, alertProvider, confirm) {

    var option = dialogOption || {};
    $scope.fileInputElement = {};
    $scope.mimeType = 'application/pdf';
    $scope.files = [];

    function getOrigin() {
        return {
            originId: option.originId,
            originType: option.originType
        };
    }

    function openSendContractDialog(file) {
        $modal.open({
            templateUrl: 'components/contractmanager/sendcontract.html',
            controller: 'SendContractCtrl',
            windowClass: 'modal-window',
            resolve: {
                file: function() { return file; },
                customer: function() { return $rootScope.getMember(option.originId); },
                origin: function() { return getOrigin(); }
            }
        });
    }

    $scope.filesChosen = function() {
        var files = $scope.fileInputElement.files;
        // Open a separate window for each selected contract
        for (var i = 0; i < files.length; i++) {
            openSendContractDialog(files[i]);
        }
    };

    $scope.fileInit = function(el) {
        $scope.fileInputElement = el;
        function fileChangeHandler() {
            $scope.filesChosen();
            // Reset the input value to ensure re-selection of the same file works
            el.value = '';
        }
        el.addEventListener('change', fileChangeHandler);
        $scope.$on('$destroy', function() {
            el.removeEventListener('change', fileChangeHandler);
        });
    };

    $scope.ableToEdit = function(file) {
        if ($scope.mode == 'displayFiles') { return false; }
        if((file._status == 'danger') || (file._status == 'active')) { return false; }
        return file.author_id == $scope.currentStaff.id || $scope.currentStaff.superUser;
    };

    var resendContract = function(contract) {
        server.post('/api/contract/resend', {'contractId': contract._id}, null, 'Contract sent', 'Failed to resend contract');
    };

    $scope.openSendOfferDialog = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'OfferAddCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                customer: function() { return $rootScope.getMember(option.originId); }
            }
        });
    };

    var removeContract = function(contract) {
        confirm.show('Are you sure you want to remove the contract?', {ladda: true}).then(function(resolve) {
            server.post('/api/contract/remove', null, {'contractId': contract._id}).then(function(result) {
                resolve();
                if (result.success) {
                    alertProvider.show('success', 'Contract removed');
                } else {
                    alertProvider.show('error', 'Failed to remove contract');
                }
            });
        });
    };

    $scope.tableControl = {};
    $scope.tableConfig = {
        api: {
            url: '/api/contract/get/all',
            args: {
                memberId: getOrigin().originId
            },
            transform: function(c) {
                c.sentAt = Date.newFull(c.sentAt);
                c.signedAt = Date.newFull(c.signedAt);
                c.customer = $rootScope.getMember(c.memberId);
                return c;
            },
            triggers: [{
                type: 'contract',
                condition: function(contract) {
                    return contract.memberId == getOrigin().originId;
                }
            }, {
                type: 'offer',
                condition: function(offer) {
                    return offer.user.id == getOrigin().originId;
                }
            }]
        },
        tableLimit: 10,
        hideSearch: true,
        orderColumn: '-sentAt',
        columns: [
            { field: 'name', title: 'Name' },
            { field: 'sentAt', title: 'Sent at', format: 'datetime' },
            { field: 'offer.validTo', title: 'Valid to', format: 'datetime' },
            { field: 'signedAt', title: 'Signed', format: 'datetime' },
            { field: 'legal_entity.name', title: 'Legal entity', format: 'text' }
        ],
        buttons: [
            {
                title: 'Download',
                buttonClass: 'btn-success',
                onClick: function(contract) {
                    server.get('/api/public/contract/download', {contractId: contract._id}, null, {responseType: 'blob'}).then(function(result) {
                        util.download(contract.name, null, null, result);
                    });
                }
            },
            {
                title: 'Resend contract',
                buttonClass: 'btn-warning',
                visible: function(contract) {
                    var isValidOffer = !contract.offer.validTo || Date.newFull(contract.offer.validTo) >= Date.today();
                    return !contract.signedAt && isValidOffer && $rootScope.hasPermission('Contract handling');
                },
                onClick: resendContract,
                tooltip: 'Resend contract'
            },
            {
                title: 'Go to offer',
                buttonClass: 'btn-success',
                visible: function(contract) {
                    return $rootScope.hasModule('OfferSupport') && $rootScope.hasPermission('Contract handling') && contract.offer && contract.offer.linkHash;
                },
                onClick: function(contract) {
                    var url = document.location.protocol + '//' + document.location.host + '/member#/pages/offer?linkHash=' + contract.offer.linkHash;
                    window.open(url, '_blank');
                }
            },
            {
                title: 'Change',
                buttonClass: 'btn-warning',
                visible: function(contract) {
                    return $rootScope.hasModule('OfferSupport') && $rootScope.hasPermission('Contract handling') && !contract.signedAt && Object.keys(contract.offer).length > 0;
                },
                onClick: function(contract) {
                    $modal.open({
                        templateUrl: 'views/changemodal.html',
                        controller: 'OfferChangeCtrl',
                        windowClass: 'modal-window',
                        resolve: {
                            offer: function() { return contract.offer; }
                        }
                    });
                }
            },
            {
                title: 'Remove',
                buttonClass: 'btn-danger',
                visible: function() {
                    return $rootScope.hasPermission('Remove contract');
                },
                onClick: removeContract
            }
        ]
    };

}]);

util.controller('SendContractCtrl', ['$rootScope', '$scope', '$controller', '$http', '$modalInstance', 'file', 'origin', 'customer', 'alertProvider', function($rootScope, $scope, $controller, $http, $modalInstance, file, origin, customer, alertProvider) {
    $controller('AddCtrl', {$scope: $scope});

    var cname = file.name;
    var c = cname.indexOf('.pdf');
    if (c != -1) {
        cname = cname.substring(0, c);
    }

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', value: cname, required: true},
        {name: 'message', title: 'Message', type: 'textarea' }
    ];

    $scope.getContractName = function() {
        return _.findWhere($scope.fields, {name: 'name'}).value;
    };

    $scope.sendContract = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        item.originId = customer.id;
        item.legal_entity_id = $rootScope.selectedSite && $rootScope.selectedSite.legal_entity_id;

        var fd = new FormData();
        fd.append('file', file);
        fd.append('data', JSON.stringify(item));

        $http.post('/api/contract/add', fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function() {
            alertProvider.show('success', 'Contract sent');
            $modalInstance.close();
        }).error(function() {
            alertProvider.show('error', 'Failed to send contract');
            $scope.loadingStatus.loading = false;
        });
    };
}]);

util.controller('OfferAddCtrl', ['$rootScope', '$scope', '$controller', 'server', 'customer', 'alertProvider', function($rootScope, $scope, $controller, server, customer, alertProvider) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Send offer';
    $scope.getButtonText = function() { return 'Send offer'; };

    var selectedTemplate = function() { return _.findWhere($scope.fields, {name: 'template'}).value; };

    var setAdjustTemplate = function() {
        var mt = _.findWhere($scope.fields, {name: 'modifiedTemplate'});
        mt.value = selectedTemplate().templateText;
    };

    var setDefaultTemplate = function() {
        if ($scope.templates.length > 0) {
            _.findWhere($scope.fields, {name: 'template'}).value = $scope.templates[0];
            setAdjustTemplate();
        }
    };

    function buildFields() {
        $scope.fields = [
            {hint: 'SEND_OFFER_HINT', hintClass: 'alert-info'},
            {name: 'message', title: 'Message', type: 'textarea', required: false},
            {name: 'validTo', title: 'Valid to', type: 'date', required: true},
            {name: 'template', title: 'Template', type: 'select', required: true, options: function() {return $scope.templates; }, placeholder: 'No template', change: setAdjustTemplate, useId: true},
            {name: 'modifiedTemplate', title: 'Adjust template', type: 'htmleditor', required: true}
        ];
    }

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        var args = { userId: customer.id, modifiedTemplate: item.modifiedTemplate, validTo: item.validTo, message: item.message};
        server.post('/api/offer/add', args, null).then(function (result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                alertProvider.show('success', 'Offer was sent');
                $scope.$close();
            } else {
                alertProvider.show('error', 'Failed to send offer');
            }
        });
    };

    $scope.setInitialValues = function() {
        server.get('/api/mailing/template/get/all', {type: 'offer'}).then(function(result) {
            $scope.templates = result;
            buildFields();
            setDefaultTemplate();
        });
    };
    $scope.setInitialValues();
}]);

util.controller('OfferChangeCtrl', ['$rootScope', '$scope', '$controller', 'server', 'alertProvider', 'offer', function($rootScope, $scope, $controller, server, alertProvider, offer) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = offer;
    $scope.fields = [
        {name: 'validTo', title: 'Valid to', type: 'date', required: true}
    ];
    $scope.setValues($scope.item);

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        $scope.loadingStatus.loading = true;
        server.post('/api/offer/change', null, {id: item.id, validTo: item.validTo}).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                alertProvider.show('success', 'Offer was changed');
                $scope.$close();
            } else {
                alertProvider.show('error', 'Failed to change offer');
            }
        });
    };
}]);